var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20_627)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.6794 14.8397C29.6794 6.64395 23.0354 0 14.8397 0C6.64395 0 0 6.64395 0 14.8397C0 22.2465 5.42663 28.3858 12.521 29.4991V19.1293H8.7531V14.8397H12.521V11.5703C12.521 7.85113 14.7365 5.79676 18.1262 5.79676C19.7493 5.79676 21.448 6.08659 21.448 6.08659V9.73855H19.5768C17.7334 9.73855 17.1584 10.8825 17.1584 12.0573V14.8397H21.2741L20.6162 19.1293H17.1584V29.4991C24.2528 28.3858 29.6794 22.2465 29.6794 14.8397Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20_627"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.6794,
    height: 29.6794,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.d3b715af35b77c80655f9ac4c8bc3fbc.svg";
export { ForwardRef as ReactComponent };